import { useMemo, memo, useCallback } from 'react';
import clsx from 'clsx';

// Imports => Config
import config from '@config';

// Imports => Constants
import {ICONS} from '@opp/ui-kit';

// Imports => Atoms
import {AcButton, AcIcon} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-notice ac-two-factor-notice',
  READY: 'ac-notice--ready',
};

const AcTwoFactorNotice = ({data, t}) => {
  const isReady = useMemo(() => {
    return data;
  }, [data]);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, isReady && _CLASSES.READY);
  }, [isReady]);

  const goTo2FALink = useCallback(() => {
    window.open(`${config.pkce.accounts_uri}/dashboard/account-and-security/two-factor/setup/select-method`, '_blank');
  }, []
  );

  return (
    <header
      id={'ac-two-factor-notice'}
      className={getMainClassNames}
      onClick={goTo2FALink}
    >
      <AcIcon icon={ICONS.SHIELD_LOCK_OUTLINE} />
      {t('enable-two-fa-text', 'Make your account extra secure by setting up two-factor authentication', {ns: 'common'})}
      <AcButton onClick={goTo2FALink}>
        <span>{t('set-up-two-fa', 'Set up two-factor authentication', {ns: 'common'})}</span>
        <AcIcon icon={ICONS.OPEN_IN_NEW} />
      </AcButton>
    </header>
  );
};

export default withTranslation(['common'])(memo(AcTwoFactorNotice));
